import { useJsApiLoader, GoogleMap, Marker, Polyline } from "@react-google-maps/api";
import { googleApiKey } from "../utils/config";


function LocationMap(props) {
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: googleApiKey
    })

    return(
        <div className={props.className || "flex justify-center items-center bg-black p-8 fixed top-0 left-0 h-screen w-screen bg-opacity-60"}>
            <div className="px-4 w-full">
                {/* <div className="flex justify-between">  
                    <div className="flex-1 font-semibold text-center text-white text-lg ">{`${props.locations.name} - ${props.locations.address}`}</div> 
                    <button onClick={() => props.setShowModal(false)} className={`bg-red-600 text-white font-bold border border-black flex justify-center items-center py-2 px-6 rounded-md cursor-pointer font-family-audiowide`}><b>X</b></button>
                </div> */}
                <div className="h-96 w-full">
                    {
                        isLoaded ?
                        <GoogleMap
                            center={{lat: +props.locations.lat, lng: +props.locations.lng}} 
                            zoom={8} 
                            mapContainerStyle={{width: '100%', height: '100%'}} 
                            options={{
                                mapTypeControl: false,
                                streetViewControl: false,
                                fullscreenControl: false,
                            }}
                        >
                            <Marker position={{lat: +props.locations.lat, lng: +props.locations.lng}} label={'Hub'} title={props.locations.name} />
                            {
                                props.locations.spokes.map((spoke, ind) => <Marker key={ind} label={'Spoke'} title={spoke.name} position={{lat: spoke.lat, lng: spoke.lng}} />)
                            }
                            {
                                props.locations.spokes.map((spoke, ind) => <Polyline key={ind} path={[{lat: +props.locations.lat, lng: +props.locations.lng}, {lat: spoke.lat, lng: spoke.lng}]} />)
                            } 
                        </GoogleMap>
                        :
                        'Unable to Load Map! Please try again!'
                    }
                </div>
            </div>
        </div>
    )
}

export default LocationMap;